import { Order } from "./Order";
import { Return } from "./Return";
import { User } from "./User";

export class DataOrder {
    id: number;
    domain: number;
    nid: string;
    user: User;
    orders: Order[];
    status: string;
    role: string;
    dataBank:{
        ds_SignatureVersion: string;
	    ds_MerchantParameters: string;
	    ds_Signature: string;
    };
    receiptOrders: string;
    token: string;
    errorCode: {
        message: string,
        code: string
    };
    orderNumberBank: string;
    orderPending: number;
    pdfName: string;
    noc: string
    storeTicketNumber?: string
    devolution?: boolean
    orderReturn?: Return;
    cloth?: string;
}